import { lazy, useEffect } from 'react';
import { isUndefined } from 'lodash';
import { getSessionUserCookiesState } from '@client/selectors/helpers/session';
import { useSelector } from '@client/hooks/redux.hooks';
import { setAcceptsCookies } from '@client/intercom';
import { Loader } from '@client/components/common/Loader';

const CookieBannerComponentLoader = lazy(() => import('./CookieBannerComponent'));

export const CookieBanner = () => {
  const acceptsCookies = useSelector(getSessionUserCookiesState);
  const displayAcceptsCookies = isUndefined(acceptsCookies) || acceptsCookies === null;

  useEffect(() => {
    if (!displayAcceptsCookies) {
      setAcceptsCookies(acceptsCookies);
    }
  }, [acceptsCookies, displayAcceptsCookies]);

  if (displayAcceptsCookies) {
    return <Loader load={CookieBannerComponentLoader} />;
  }

  return null;
};
